import { SpinResponse } from '@cgs/data-access';

export class ResponseHolder<TResponse extends SpinResponse> {
  curResponse: TResponse;
  preResponse: TResponse | null = null;
  curServerResponse: TResponse | null = null;
}
